import React from 'react';
import { toast } from 'react-toastify';
import {
    CALL_CONVERSION_STATUS_ACCEPT, 
    CALL_CONVERSION_STATUS_DECLINE,
    CALL_CONVERSION_STATUS_CANCEL,
    CALL_CONVERSION_STATUS_REQ_WAITING,
    CALL_CONVERSION_STATUS_REQUEST_INIT,
    CALL_CONVERSION_STATUS_REQUEST
} from '../../Helpers/Call/Constant';
import { getFormatPhoneNumber } from '../../Helpers/Utility';
import { getUserDetails } from '../../Helpers/Chat/User';
import { showModal } from '../../Redux/feature/popUpDataSlice';
import { store } from '../../Redux/store';
import SDK from '../../SDK';
import { addCallConversion } from '../../Redux/feature/callConversionDataSlice';
import { useSelector } from 'react-redux';
import { addShowConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';


// Need to declare as a global variable to maintian call conversion interval state
// Because to avoid the below issue,
// Open confirmation popup which contain SWITCH & CANCEL,
// first click SWITCH & then immediately click CANCEL, then the popup would close & 
// again popup would open with request wating process, at this time click cancel wouldn't
// stop the interval If we declare this interval state varaible as class variable 
let callConverisonInterval = null;

const CallConversionPopup = (props) => {
    
    const datas = store.getState()?.showConfrenceData?.data || {};
    const getStore = useSelector(state => state)
    const getReceiverName = getStore.callConnectionDate?.data
    const {callConversionData} = getStore
    const { data: { status } } = callConversionData;

    React.useEffect(()=>{
        if(callConversionData && 
            [
                CALL_CONVERSION_STATUS_DECLINE, 
                CALL_CONVERSION_STATUS_CANCEL, 
                CALL_CONVERSION_STATUS_ACCEPT
            ].indexOf(status) > -1
        ){
            if(status === CALL_CONVERSION_STATUS_DECLINE){
                props.resetCallConversionRequestData();
            }
            clearInterval(callConverisonInterval);            
            store.dispatch(addCallConversion());
        }
    },[status])

    React.useEffect(() => { 
        return () => { 
            if(callConversionData?.data?.status === "accept"){
                clearInterval(callConverisonInterval);
                store.dispatch(addCallConversion());
            }
        } 
    },[status]); 
    
    let fromUserName = null

    if(datas.fromJid){
        const fromUser = datas.fromJid;
        const fromUserDetail = getUserDetails(fromUser);
        fromUserName = (fromUserDetail && (fromUserDetail.displayName || fromUserDetail.name)) || getFormatPhoneNumber(fromUser);
    }

    const handleAction = async (statusToUpdate) => {
        if(!statusToUpdate){
            store.dispatch(addCallConversion());
            return;
        }       

        // If the request initiator status is 'request_waiting', then need to send 'request' status to
        // remote users. That's why below we change the statusToSend value
        // const statusToSend = statusToUpdate === CALL_CONVERSION_STATUS_REQ_WAITING ? 'request' : statusToUpdate;
        // const callConversionRes = await SDK.callConversion(statusToSend);
        let callConversionRes = null;
        if(statusToUpdate === CALL_CONVERSION_STATUS_ACCEPT){
            callConversionRes = await SDK.acceptVideoCallSwitchRequest();
            props.resetCallConversionRequestData();
        } else if(statusToUpdate === CALL_CONVERSION_STATUS_REQUEST_INIT){
            callConversionRes = await SDK.requestVideoCallSwitch();    
        } else if(statusToUpdate === CALL_CONVERSION_STATUS_REQ_WAITING){
            callConversionRes = await SDK.requestVideoCallSwitch();    
        }

        if(callConversionRes && callConversionRes.statusCode === 500){
            store.dispatch(addCallConversion({status: CALL_CONVERSION_STATUS_CANCEL}));
            // When user accept the request & If camera access thrown error, then send the decline request.
            if(statusToUpdate === CALL_CONVERSION_STATUS_ACCEPT){
                await SDK.declineVideoCallSwitchRequest();
            }
            store.dispatch(showModal({
                open: true,
                modelType: 'mediaPermissionDenied',
                statusCode: 100607
            }));
            const { data = {} } = store.getState().showConfrenceData;
            store.dispatch(addShowConfrenceData({ ...data, videoPermissionDisabled: true }));
            return;
        }
        store.dispatch(addCallConversion({status: statusToUpdate}));

        if(statusToUpdate === CALL_CONVERSION_STATUS_REQ_WAITING){
            let timeLeft = 20;
            clearInterval(callConverisonInterval);
            callConverisonInterval = setInterval(async () => {
                if(timeLeft === 0){
                    const fromUserDetail = getUserDetails(getReceiverName);
                    const fromReceiverUserName = (fromUserDetail && (fromUserDetail.displayName || fromUserDetail.name)) || getFormatPhoneNumber(getReceiverName);
                    clearInterval(callConverisonInterval);
                    store.dispatch(addCallConversion({status: CALL_CONVERSION_STATUS_CANCEL}));
                    await SDK.cancelVideoCallSwitchRequest();
                    props.resetCallConversionRequestData();
                    toast.error(`No response from ${fromReceiverUserName}`);
                } else {
                    timeLeft = timeLeft - 1;
                }
            }, 1000)
        }

        if(statusToUpdate === CALL_CONVERSION_STATUS_DECLINE){
            clearInterval(callConverisonInterval);
            await SDK.declineVideoCallSwitchRequest();
        }

        if(statusToUpdate === CALL_CONVERSION_STATUS_CANCEL){
            clearInterval(callConverisonInterval);
            props.resetCallConversionRequestData();
            await SDK.cancelVideoCallSwitchRequest();
        }
    }

    if(!status) return null;

    let content = null;
    let cancelBtnLabel = null;
    let confirmBtnLabel = null;
    let cancelStatusToUpdate = null;
    let confirmStatusToUpdate = null;
    
    if(status === CALL_CONVERSION_STATUS_REQUEST_INIT){ // Request initiator
        content = 'Are you sure you want to switch to Video call?';
        cancelBtnLabel = 'CANCEL';
        confirmBtnLabel = 'SWITCH';
        confirmStatusToUpdate = CALL_CONVERSION_STATUS_REQ_WAITING;
    }
    else if(status === CALL_CONVERSION_STATUS_REQ_WAITING){ // Request initiator
        content = 'Requesting to switch to video call.';
        cancelBtnLabel = 'CANCEL';
        cancelStatusToUpdate = CALL_CONVERSION_STATUS_CANCEL;
        if(props.remoteUserRequestingCallSwitch){
            handleAction(CALL_CONVERSION_STATUS_ACCEPT);
        }
    }
    else if(status === CALL_CONVERSION_STATUS_REQUEST){ // Request receiver
        content = `${fromUserName} Requesting to switch to video call`;
        cancelBtnLabel = 'DECLINE';
        cancelStatusToUpdate = CALL_CONVERSION_STATUS_DECLINE;
        confirmBtnLabel = 'ACCEPT';
        confirmStatusToUpdate = CALL_CONVERSION_STATUS_ACCEPT;
        if(props.currentUserRequestingCallSwitch){   
            handleAction(CALL_CONVERSION_STATUS_ACCEPT);
        }
    } else if(status === CALL_CONVERSION_STATUS_ACCEPT){
        props.resetCallConversionRequestData();
    }

    if(!content) return null;

return(
    <>
        <div className="popup-wrapper call-conversion-popup">
            <div className={`popup-container`}>
                <div className="popup-container-inner">
                    <div className="popup-label">
                        <label>{content}</label>
                    </div>
                    <div className="popup-noteinfo">
                        {cancelBtnLabel && <button type="button" onClick={() => handleAction(cancelStatusToUpdate)} className="btn-cancel" >{cancelBtnLabel}</button>}
                        {confirmBtnLabel && <button type="button" onClick={() => handleAction(confirmStatusToUpdate)} className="btn-active">{confirmBtnLabel}</button>}
                    </div>
                </div>
            </div>
        </div>
    </>

)}
export default CallConversionPopup;